export enum CapacityEnum {
  RMS_MAX_CAPACITY_DEFAULT = 99999,
  MIN_VALUE_INPUT_NUMBER= 0,
}
